import { render, staticRenderFns } from "./GiftPromptModal.vue?vue&type=template&id=ba1cc3e6&scoped=true"
import script from "./GiftPromptModal.vue?vue&type=script&lang=js"
export * from "./GiftPromptModal.vue?vue&type=script&lang=js"
import style0 from "./GiftPromptModal.vue?vue&type=style&index=0&id=ba1cc3e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8d78c4fc2b2e880cb3796fb82bca3a94/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1cc3e6",
  null
  
)

export default component.exports